import { KoAPI } from "packages";
import { configs } from 'configuration';
const version = configs().API_VERSION;

export const PollAPI = {

  getPolls(query) {
    return KoAPI.get(`/api/${version}/admin/poll/list`, { query: { ...query } });
  },
  createPoll(data) {
    return KoAPI.post(`/api/${version}/admin/poll`, {data});
  },
  getUsers(){
    return KoAPI.get(`/api/${version}/org/user`);
  },
  getGroups(){
    return KoAPI.get(`/api/${version}/org/group`);
  }

};